module.exports = __webpack_public_path__ + "VIPV34.png?83c8cee02a0292945ee4dd18c2771d88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV34.png
// module id = 130
// module chunks = 0